import api from "../../config/base";
import {
  FETCH_CAPABILITIES_SUCCESS,
  FETCH_CAPABILITIES_ERROR,
  FETCH_CAPABILITY_SUCCESS,
  FETCH_CAPABILITY_ERROR,
  CREATE_CAPABILITY_SUCCESS,
  CREATE_CAPABILITY_ERROR,
  UPDATE_CAPABILITY_SUCCESS,
  UPDATE_CAPABILITY_ERROR,
  DELETE_CAPABILITY_SUCCESS,
  DELETE_CAPABILITY_ERROR,
} from "./types";

// Get all capabilities
export const fetchCapabilities = () => async (dispatch) => {
  try {
    const res = await api.get('/capabilities');
    dispatch({
      type: FETCH_CAPABILITIES_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CAPABILITIES_ERROR,
      payload: error.message,
    });
  }
};

// Get a capability by ID
export const fetchCapabilityById = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/capabilities/${id}`);
    dispatch({
      type: FETCH_CAPABILITY_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_CAPABILITY_ERROR,
      payload: error.message,
    });
  }
};

// Create a new capability
export const createCapability = (capability) => async (dispatch) => {
  try {
    const res = await api.post('/capabilities', capability);
    dispatch({
      type: CREATE_CAPABILITY_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: CREATE_CAPABILITY_ERROR,
      payload: error.message,
    });
  }
};

// Update a capability by ID
export const updateCapability = (id, capability) => async (dispatch) => {
  try {
    const res = await api.put(`/capabilities/${id}`, capability);
    dispatch({
      type: UPDATE_CAPABILITY_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_CAPABILITY_ERROR,
      payload: error.message,
    });
  }
};

// Delete a capability by ID
export const deleteCapability = (id) => async (dispatch) => {
  try {
    await api.delete(`/capabilities/${id}`);
    dispatch({
      type: DELETE_CAPABILITY_SUCCESS,
      payload: id,
    });
  } catch (error) {
    dispatch({
      type: DELETE_CAPABILITY_ERROR,
      payload: error.message,
    });
  }
};
